import React from "react";
import {Page} from "@insticator/insticator-ui";
import Loading from "../states/loading/loading";
import injectSheet from "react-jss";
import styles from './sectionloader_styles';


// use this to display centered loader in a section
const SectionLoader = injectSheet(styles)((props) => {
    const {
        classes
    } = props;

    return <Page klass={classes.loading}><Loading/></Page>
})

export default SectionLoader;


